const IMAGES = {
  logo: require("../assets/sunculture-logo.png"),
  homeWarning: require("../assets/danger.png"),
  note: require("../assets/note.png"),
  product: require("../assets/product.png"),
  income: require("../assets/income.png"),
  social: require("../assets/social-impact.png"),
  spending: require("../assets/spending.png"),
  user: require("../assets/user.png"),
  rocket: require("../assets/rocket.png")
};

export default IMAGES;
